<template>
  <a-config-provider :locale="antdLocale">
    <a-app>
      <NotificationModal />
      <error v-show="isAppCrashed" />
      <RouterView v-show="!isAppCrashed" />
    </a-app>
  </a-config-provider>
</template>

<script setup>
import 'driver.js/dist/driver.css'
import { computed, onErrorCaptured, provide, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterView } from 'vue-router'
import deDE from 'ant-design-vue/es/locale/de_DE'
import enUS from 'ant-design-vue/es/locale/en_US'
import itIT from 'ant-design-vue/es/locale/it_IT'
import Error from './components/Core/ErrorComponent.vue'
import NotificationModal from './components/User/Notification/Notification.vue'

const { t, locale } = useI18n()

// Ant Design ships its own strings for the chrome we never write ourselves:
// modal OK/Cancel, table "No data", pagination, date pickers, select "Not
// Found". Without a ConfigProvider they stay English regardless of $t().
const ANTD_LOCALES = { en: enUS, de: deDE, it: itIT }
const antdLocale = computed(() => {
  const base = ANTD_LOCALES[locale.value] ?? enUS
  // ant-design-vue's it_IT locale still ships the table filter reset as "Reset", and
  // de_DE/it_IT omit the filter search placeholder, so antd falls back to English.
  return {
    ...base,
    Table: {
      ...base.Table,
      filterReset: t('common.reset'),
      filterSearchPlaceholder: t('folders.search_in_filters')
    }
  }
})

const isAppCrashed = ref(false)

provide('hideError', () => {
  isAppCrashed.value = false
})

onErrorCaptured((error) => {
  // whitelist media error
  if (error.message.indexOf('media') >= 0) return
  // INFO: Error captured by global handler and reported to Sentry.
  isAppCrashed.value = true
})
</script>

<style>
@import 'bootstrap-icons/font/bootstrap-icons.css';
@import 'main.css';
@import 'styles/index.css';
@import 'styles/components.css';

.full-modal .ant-modal {
  max-width: 100%;
  top: 0;
  padding-bottom: 0;
  margin: 0;
}

.full-modal .ant-modal-content {
  display: flex;
  flex-direction: column;
  height: calc(100vh);
}

.full-modal .ant-modal-body {
  flex: 1;
}

.center {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.cursor-pointer {
  cursor: pointer;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: lightgray;
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(202, 202, 202);
}

/* Driver */
.driver-active .driver-active-element {
  pointer-events: none !important;
}

.driver-active .driver-active-element * {
  pointer-events: none !important;
}

.ant-dropdown {
  z-index: 2000 !important;
}
</style>
